import ToastificationContentVue from '@/@core/components/toastification/ToastificationContent.vue'
import moment from 'moment'
import axios from '@axios'

export default {
  data() {
    return {
      produitsHiddenGlobal: [29,30,31],
      risquesHiddenGlobal: [69,74,13],
      risquesVisibleGlobal: [4, 7],
      produitsVisibleGlobal: [24, 23, 19, 32],
      currentUserGlobal: JSON.parse(localStorage.getItem('userData'))
    }
  },
  components: {
    ToastificationContentVue
  },
  methods: {
    checkIsNull(val, isAddSpaceAndComma = false, defaultVal = '') {
      if (val) {
        return isAddSpaceAndComma ? val + ', ' : val
      } else {
        return defaultVal
      }
    },
    generatePassword() {
      const char = 'abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789'
      const sym = '!@#$%^&*=-_'

      let pwd = ''
      for (var i = 0; i < 10; i++) {
        pwd += char.charAt(Math.floor(Math.random() * char.length))
      }
      for (var i = 0; i < 2; i++) {
        pwd += sym.charAt(Math.floor(Math.random() * sym.length))
      }
      return pwd
    },
    CorrectingAccentByName(str) {
      const removeAccents = str.normalize('NFD').replace(/[\u0300-\u036f]/g, '')
      const valueToUpperCase = removeAccents.toUpperCase()
      const dataSet = {
        ETUDE: 'Etude',
        'DEVIS ENVOYE': 'Devis envoyé',
        'EN ATTENTE SIGNATURE': 'En attente signature',
        'DEVIS CLOTURE SANS SUITE': 'Devis clôturé sans suite',
        'REFUSE PAR LE CLIENT': 'Refusé par le client',
        EXPIRE: 'Expiré'
      }
      return dataSet[valueToUpperCase]
    },
    sourceVariant(value) {
      const valueToUpperCase = value.toUpperCase()
      const sourceColor = {
        OUI: 'light-success',
        NON: 'light-danger',

        EXTERNE: 'light-primary',
        INTERNE: 'light-warning',

        ACTIF: 'light-success',
        INACTIF: 'light-danger',
        ADMINISTRATOR: 'light-success',
        UTILISATEURBUBBLEIN: 'light-success',
        NONUTILISATEURBUBBLEIN: 'light-dark',

        PARTICULIER: 'light-danger',
        PROFESSIONNEL: 'light-warning',
        ENTREPRISE: 'light-success',

        CLIENT: 'light-warning',
        UTILISATEUR: 'light-info',

        DECLARANTTRACFIN: 'light-primary',
        DPO: 'light-info',
        CORRESPONDANTTRACFIN: 'light-warning',

        AUTRE: 'light-secondary',

        'RENDEZ-VOUS': 'light-warning',
        TÂCHE: 'light-primary',
        MESSAGE: 'light-secondary',


        'CONVENTION NON SIGNE': 'light-info',
        'ATTENTE VALIDATION': 'light-warning',
        'SIGNATURE PROTOCOLE': 'light-danger',
        OPERATIONNEL: 'light-success',
        'DEFAUT PAIEMENT': 'light-danger',
        'DEFAUT FRAUDE': 'light-danger',
        'DEFAUT DESINSCRIPTION': 'light-danger',
        'RESILIE COURTIER': 'light-secondary',

        PROJET: 'light-primary',
        CONTRAT: 'light-info',

        ECONOMIQUE: 'light-success',
        COMPLÈTE: 'light-warning',
        'HAUT DE GAMME': 'light-danger',

        EN_ATTENTE:'light-warning',
        EN_COURS: 'light-success',
        NON_INITIE: 'light-secondary'

      }
      return sourceColor[valueToUpperCase]
    },
    messageToast(textReceived, titleReceived, variantReceived = 'primary', iconReceived = 'BellIcon', timeoutReceived = 3000) {
      let dataProps = {
        title: titleReceived,
        icon: iconReceived,
        text: textReceived,
        variant: variantReceived,
      }
      this.$toast({
        component: ToastificationContentVue,
        props: dataProps
      }, {
        timeout: timeoutReceived
      })
    },
    changeFormatDateLong(date) {
      return date ? moment(date)
        .lang('fr')
        .format('LL') : null
    },
    changeFormatDateShort(date) {
      return date ? moment(date)
        .lang('fr')
        .format('L') : null
    },
    changeFormatDateTimeShort(date) {
      return date ? moment(date)
        .lang('fr')
        .format('DD/MM/YYYY HH:mm') : null
    },
    changeFormatDateShortNormal(date) {
      return date ? moment(date)
        .lang('fr')
        .format('DD/MM/YYYY') : null
    },
    changeFormatDateTimeString(date) {
      return date ? moment(date).toString() : null
    },
    ValidateEmail(mail) {
      if (/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(mail)) {
        return true
      }
      return false
    },
    capitalizeFirstLetter(string) {
      return string ? string.charAt(0)
      .toUpperCase() + string.slice(1) : ''
    },
    formatUserName(prenom, nom) {
      return prenom.charAt(0).toUpperCase() + prenom.slice(1).toLowerCase() + ' ' + nom.toUpperCase()
    },
    formattingDateSql(date) {
      if (date) {
        let date_formatting = date
        date_formatting = date_formatting.split("-")
        date_formatting = date_formatting[2] + "/" + date_formatting[1] + "/" + date_formatting[0];
        return date_formatting;
      }
      return null;
    },
    datesChecker(dateDebut, DateFin) {
      if (moment(dateDebut, 'DD/MM/YYYY hh:mm').diff(moment(DateFin, 'DD/MM/YYYY hh:mm')) >= 0) {
        return false
      }
      return true
    },
    checkUndefined(val) {
      return val === undefined ? 0 : val;
    },
    isBoitEmailSync() {
      let userData = JSON.parse(localStorage.getItem('userData'))
      return new Promise((resolve, reject) => {
        axios
          .post(`evenements/userHasBoiteEmailSync`, {
            user_id: userData.id
          })
          .then(response => {
            if (response.data.email && response.data.id)
              resolve(true)

            resolve(false)
          })
          .catch(error => reject(error))
      })
    },
    hasCodeProduit(produit_id) {
      let userData = JSON.parse(localStorage.getItem('userData'))
      let isAutorised = undefined
      if(userData.courtier_user[0].courtier.hasOwnProperty("produits_autorise"))
        isAutorised = userData.courtier_user[0].courtier.produits_autorise.find(p => p.produit_id == produit_id)
        
      if(isAutorised !== undefined)
        return true

      return false
    },
    formatText(str, format='upper') {
      var map = {
        '-': ' ',
        '-': '_',
        'a': 'á|à|ã|â|ä|À|Á|Ã|Â|Ä',
        'e': 'é|è|ê|ë|É|È|Ê|Ë',
        'i': 'í|ì|î|ï|Í|Ì|Î|Ï',
        'o': 'ó|ò|ô|õ|ö|Ó|Ò|Ô|Õ|Ö',
        'u': 'ú|ù|û|ü|Ú|Ù|Û|Ü',
        'c': 'ç|Ç',
        'n': 'ñ|Ñ'
      };
      for (var pattern in map) {
        str = str.replace(new RegExp(map[pattern], 'g'), pattern);
      };
      var result = str.split(' ').join('')
      if(format == 'upper')
        return result.toUpperCase()
      else if (format == 'lower')
        return result.toLowerCase()
      else
        return result
    },
    validateURL(url = '') {
      var tarea = url;
      if (tarea.indexOf("http://") == 0 || tarea.indexOf("https://") == 0) {
        return url;
      }
      return 'http://' + url;

    },
    fnBrowserDetect(){
                 
      let userAgent = navigator.userAgent;
      let browserName;
      
      if(userAgent.match(/chrome|chromium|crios/i)){
          browserName = "chrome";
        }else if(userAgent.match(/firefox|fxios/i)){
          browserName = "firefox";
        }  else if(userAgent.match(/safari/i)){
          browserName = "safari";
        }else if(userAgent.match(/opr\//i)){
          browserName = "opera";
        } else if(userAgent.match(/edg/i)){
          browserName = "edge";
        }else{
          browserName="autre";
        }

        return browserName
    },
    hideToolbar() {
      let styleToolbar = [
        {name: 'chrome', params: {'margin-top': '-56px', 'height': 'calc(100% + 56px)'}},
        {name: 'firefox', params: {'margin-top': '-35px', 'height': 'calc(100% + 35px)'}},
        {name: 'safari', params: {'margin-top': '-56px', 'height': 'calc(100% + 56px)'}},
        {name: 'opera', params: {'margin-top': '-56px', 'height': 'calc(100% + 56px)'}},
        {name: 'edge', params: {'margin-top': '-56px', 'height': 'calc(100% + 56px)'}},
        {name: 'autre', params: {'margin-top': '-56px', 'height': 'calc(100% + 56px)'}},
      ]
      
      return styleToolbar.find((br) => {
        return br.name == this.fnBrowserDetect()
      }).params
    },
    numberFormatCurrency(number) {
      if(number)
        return new Intl.NumberFormat('nb-NO').format(parseFloat(number.replace(/,/g, '.'))) + '€'
      return ''
    },
    getUrlbase64(base64){
      const byteCharacters = atob(base64.substr(base64.indexOf(',') + 1));
      const byteNumbers = new Array(byteCharacters.length);
      for (let i = 0; i < byteCharacters.length; i++) {
        byteNumbers[i] = byteCharacters.charCodeAt(i);
      }
      const byteArray = new Uint8Array(byteNumbers);
      const blo = new Blob([byteArray], {type: 'application/pdf'});

      var blob = new Blob([blo], {type: 'application/pdf'});
      var blobURL = URL.createObjectURL(blob);

      return blobURL
    },
    getModeTrans(toEspaceProspect = false, toMailClient = false, toMailCourtier = false) {
      if(toEspaceProspect)
        return 'ESPACE_PROJET'
      if(toMailClient && toMailCourtier)
        return 'MAIL'
      else if(toMailClient)
        return 'MAIL_PROSPECT'
      else if(toMailCourtier)
        return 'MAIL_COURTIER'
      else return 'AUCUN'
    },
    getStaticExigencesProtectionJuridique() {
      return [
        {
          text : "<b>Santé</b> - Victime d'agression ou d'une erreur médicale"
        },
        {
          text : "<b>Habitation</b> - Difficulté avec le syndicat de copropriété, un voisin"
        },
        {
          text : "<b>Consommation</b> - De biens et services"
        },
        {
          text : "<b>Travail salarié</b> - <b>Emploi familiaux</b>"
        },
        {
          text : "<b>Services publics</b> - <b>Fiscalité</b>"
        }
      ]
    },
    canShowProduit(produit_id = null, risque_id = null) {
      let groupes = this.currentUserGlobal.courtier_user[0].courtier.courtier_relation_dependant
      if(((risque_id && this.risquesVisibleGlobal.includes(risque_id)) 
        || (produit_id && this.produitsVisibleGlobal.includes(produit_id)))) {
          return true
      } else if(((risque_id && this.risquesHiddenGlobal.includes(risque_id)) 
      || (produit_id && this.produitsHiddenGlobal.includes(produit_id))) 
      && (groupes != undefined && groupes.length <= 0)) {
        return false
      } else if(((risque_id && !this.risquesHiddenGlobal.includes(risque_id)) 
        || (produit_id && !this.produitsHiddenGlobal.includes(produit_id))) 
        && (groupes != undefined && groupes.length > 0)) {
          return false
      }
      return true
    },
  }
}